import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FormPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    service: '',
    message: '',
    // graduation: '',
    mobile: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Cookie', 'ci_session=udv0s1f5ihar7loftmekahqe73q2u62j');

    const raw = JSON.stringify(formData);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    try {
      const response = await fetch(
        'https://moerp.modevcloud.com/index.php/api/Enquiries_api/save',
        requestOptions,
      );
      const result = await response.text();
      console.log(result);

      // Redirect to Thank You page
      navigate('/thank-you');
    } catch (error) {
      console.error(error);
      alert('Error submitting form.');
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-xl shadow-lg mt-10 mb-10">
      <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full p-2 border rounded"
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full p-2 border rounded"
        />
        <input
          type="tel"
          name="mobile"
          placeholder="Your Mobile Number"
          value={formData.mobile}
          onChange={handleChange}
          required
          className="w-full p-2 border rounded"
        />
        <select
          name="service"
          value={formData.service}
          onChange={handleChange}
          required
          className="w-full p-2 border rounded"
        >
          <option value="">Select a Service</option>
          <option value="Custom Website Development">
            Custom Website Development
          </option>
          <option value="E-commerce Solutions">E-commerce Solutions</option>
          <option value="CMS Development (WordPress, Joomla, Drupal)">
            CMS Development (WordPress, Joomla, Drupal)
          </option>
          <option value="Web Application Development">
            Web Application Development
          </option>
          <option value="Android App Development">
            Android App Development
          </option>
          <option value="iOS App Development">iOS App Development</option>
          <option value="Hybrid App Development (React Native, Flutter)">
            Hybrid App Development (React Native, Flutter)
          </option>
          <option value="AWS, Azure, Google Cloud Solutions">
            AWS, Azure, Google Cloud Solutions
          </option>
          <option value="Cloud Migration">Cloud Migration</option>
          <option value="DevOps Services">DevOps Services</option>
        </select>
        {/* <select
          name="graduation"
          value={formData.graduation}
          onChange={handleChange}
          required
          className="w-full p-2 border rounded"
        >
          <option value="">Select a graduation</option>
          <option value="MBA">MBA</option>
          <option value="graduation">B-Tech</option>
          <option value="BCA">BCA</option>
          <option value="MCA">MCA</option>
          <option value="M-tech">M-Tech</option>
          <option value="BBA">BBA</option>
        </select> */}
        <textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
          className="w-full p-2 border rounded"
        />

        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default FormPage;
